export default __webpack_public_path__ + "static/media/farFromHome.a13351e6.png";